// extracted by mini-css-extract-plugin
export default {"bodyScrollbar":"Sidebar_bodyScrollbar__TMwYv","panel":"Sidebar_panel__qk7lV","activeLink":"Sidebar_activeLink__NLkVB"};